import { EventEmitter, Input, Output } from "@angular/core";
import { IFilterData, IFilterModel } from "./filter-model";
import { Filter } from "./filter";

export abstract class FilterCustomModel {

    public label!: string;
    public key!: string;
    public field!: string;
    public groupId!: string;

    onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

    protected data: IFilterData[] = [];
    protected filter = new Filter();

    abstract onLoad(): void;
    abstract onSearch(event: any): void;

}
